import icon from './icon.svg';
import './index.css';

function PrivacyPolicy() {
    return (
        <div id="privacy" className="privacy_block">
            <img src={icon} className="privacy_icon" alt="icon" />
            <div className="privacy_textblock">
                <div className="privacy_headline">Privacy Policy</div>
                <p className="privacy_desc">
                    It may be used to help support your customer relationship
                    with us if you provide the personal infomation. Unless
                    required or permitted by law, we will not collect or use the
                    personal information you send for any unrelated purpose
                    without prior notice. If the contact information you provide
                    includes the personal data of a third party, you confirm
                    that the third party is aware of the rights in this Privacy
                    Statement, and warrant that you have obtained the consent of
                    the third party to authorize us to comply with this Privacy
                    Statement. The purpose of collection is to use the personal
                    data of a third party. If you do not provide or you request
                    to stop collecting, processing, utilizing, we will not be
                    able to contact you about service-related matters, and
                    provide you with the latest service information. When your
                    rights and interests are impaired, we are not responsible
                    for the continued service and compensation.
                </p>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
